var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Modal as OriginalModal } from "react-bootstrap";
const Modal = Object.assign((_a) => {
    var { "aria-labelledby": ariaLabelledby } = _a, props = __rest(_a, ["aria-labelledby"]);
    return (React.createElement(OriginalModal, Object.assign({ "aria-labelledby": ariaLabelledby !== null && ariaLabelledby !== void 0 ? ariaLabelledby : "modalTitle" }, props)));
}, OriginalModal);
export default Modal;
//# sourceMappingURL=index.js.map